var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpperAngleBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 2.7749L2.10005 6.6749C1.91672 6.85824 1.68338 6.9499 1.40005 6.9499C1.11672 6.9499 0.883382 6.85824 0.700049 6.6749C0.516715 6.49157 0.425049 6.25824 0.425049 5.9749C0.425049 5.69157 0.516715 5.45824 0.700049 5.2749L5.30005 0.674902C5.40005 0.574902 5.50838 0.504069 5.62505 0.462402C5.74172 0.420736 5.86672 0.399902 6.00005 0.399902C6.13338 0.399902 6.25838 0.420736 6.37505 0.462402C6.49172 0.504069 6.60005 0.574902 6.70005 0.674902L11.3 5.2749C11.4834 5.45824 11.575 5.69157 11.575 5.9749C11.575 6.25824 11.4834 6.49157 11.3 6.6749C11.1167 6.85824 10.8834 6.9499 10.6 6.9499C10.3167 6.9499 10.0834 6.85824 9.90005 6.6749L6.00005 2.7749Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperAngleBracket);
export default __webpack_public_path__ + "static/media/upper-angle-bracket.a493b53a2de5e2cf3b944a0eb58807ab.svg";
export { ForwardRef as ReactComponent };